import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import PrivateRouter from './PrivateRouter';
import Loadable from 'react-loadable';
import { Logout } from './views';
import { useCookies } from 'react-cookie';
import './axiosInterceptor';
import './App.scss';

const loading = () => (
    <div className='animated fadeIn pt-3 text-center'>
        <div className='sk-spinner sk-spinner-pulse'></div>
    </div>
);

// Containers
const DefaultLayout = Loadable({
    loader: () => import('./containers/DefaultLayout'),
    loading,
});

const App = () => {
    const [cookies] = useCookies(['userdata']);
    return (
        <HashRouter>
            <Switch>
                <Route exact path='/logout' component={Logout} />
                <PrivateRouter isAuthenticated={!!(cookies.userdata || false)} path='/' component={DefaultLayout} />
            </Switch>
        </HashRouter>
    );
};

export default App;
